import _ from "lodash";

export const sortBooks = function(books) {
    return _.orderBy(
        books,
        [
            book => book.recommendations.length,
            book => {
                if (book.title.startsWith("The ")) {
                    return book.title.substring(4);
                } else if (book.title.startsWith("A ")) {
                    return book.title.substring(2);
                } else if (book.title.startsWith("An ")) {
                    return book.title.substring(3);
                }
                return book.title;
            }
        ],
        ["desc", "asc"]
    );
};



// WEBPACK FOOTER //
// ./src/utils/sortBooks.js